
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import EcoScoreSection from '@components/shared/section/EcoScoreSection.vue'

export interface StatDetail {
  name: string,
  value?: number,
  decimals?: number,
  unit?: string
}

@Component({
  name: 'TripDetailStats',
  components: {
    EcoScoreSection,
  },
})
export default class TripDetailStats extends Vue {
  @Prop()
  private title: string;

  @Prop()
  private stats: StatDetail[]

  daysDuration(stat: StatDetail) {
    return Math.floor(stat.value / (24 * 60));
  }

  hoursDuration(stat: StatDetail) {
    return Math.floor(stat.value / 60) - this.daysDuration(stat) * 24;
  }

  minutesDuration(stat: StatDetail) {
    return Math.round(stat.value) - this.hoursDuration(stat) * 60 - this.daysDuration(stat) * 24 * 60;
  }
}
